<script setup lang="ts">
import { User, UserStory } from '@/models/user.model';
import { ShiftCMSState } from '@/store';
import { UsersActions, UsersState } from '@/stores/users.store';
import { computed, PropType } from 'vue';
import { useStore } from 'vuex';
import { format } from 'date-fns';

const props = defineProps({
  user: {
    type: Object as PropType<User>,
    required: true,
  },
});

const store = useStore<ShiftCMSState & { us: UsersState }>();

const stories = computed<UserStory[]>(() => store.state.us.userStories);

const headers = [
  { title: 'Story', key: 'story.title' },
  { title: 'Seen', key: 'presentedDate' },
  { title: 'Watched', key: 'watchedDate' },
  { title: 'Completed', key: 'completedDate' },
  { title: 'Options', key: 'options' },
];

const formatDate = (v: string): string =>
  v ? format(v, 'dd-MM-yyyy HH:mm') : ' - ';

function deleteUserStory(id: number) {
  store.dispatch(UsersActions.DeleteUserStory, { id, userId: props.user.id });
}
</script>
<template>
  <v-card class="mt-4">
    <v-card-title>Stories</v-card-title>
    <v-data-table
      density="compact"
      :headers="headers"
      :items="stories"
      itemsPerPage="10"
      hover
    >
      <template v-slot:item.presentedDate="{ value }">
        {{ formatDate(value) }}
      </template>
      <template v-slot:item.watchedDate="{ value }">
        {{ formatDate(value) }}
      </template>
      <template v-slot:item.completedDate="{ value }">
        {{ formatDate(value) }}
      </template>
      <template v-slot:item.options="{ item }">
        <v-btn
          density="compact"
          icon="mdi-delete-outline"
          @click="deleteUserStory(item.id)"
        />
      </template>
    </v-data-table>
  </v-card>
</template>
